import { RouteRecordRaw } from 'vue-router'

const Departments = () =>
  import(/* webpackChunkName: "departments-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'departamentos',
    name: 'departments',
    component: Departments,
    meta: {
      title: 'Departamentos',
      auth: {
        requiredPermission: 'departments.view',
        requiredModule: 'departments',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
